// extracted by mini-css-extract-plugin
module.exports = {"container":"MakePaymentHeader_container__ytsDA","logo":"MakePaymentHeader_logo__1nnGR","menu":"MakePaymentHeader_menu__16QQH","myAccount":"MakePaymentHeader_myAccount__3oPBK"};